import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "mt-6 overflow-clip" }
const _hoisted_3 = {
  key: 0,
  class: "mt-8 md:mt-2"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "mt-8 md:mt-2"
}
const _hoisted_6 = { class: "text-3xl font-medium capitalize" }
const _hoisted_7 = { class: "w-full mt-6 overflow-x-auto" }
const _hoisted_8 = { class: "w-full table-auto" }
const _hoisted_9 = { class: "font-bold text-left capitalize border-b-2 border-black" }
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_17 = {
  scope: "col",
  class: "px-2 py-2 whitespace-nowrap md:whitespace-normal"
}
const _hoisted_18 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_19 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_20 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_21 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_25 = { class: "px-2 py-2 divide-x-2 divide-gray-300" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { class: "py-2 whitespace-nowrap md:whitespace-normal" }, "No responses to this survey", -1)
const _hoisted_28 = [
  _hoisted_27
]

import { ref } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";

import TabGroup from "@/components/TabGroup.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import ResultsTable from "@/components/tables/ResultsTable.vue";
import SortableTableHeader from "@/components/tables/SortableTableHeader.vue";
import FilterTableHeader from "@/components/tables/FilterTableHeader.vue";
import PaginationBar from "@/components/PaginationBar.vue";

import api from "@/api/api";
import { useGlobalStore } from "@/store";
import { Event, SurveyResponse, DetailedResults, User, PaginationMeta } from "@/types";
import { useFilters } from "@/composables/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyPage',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();

const tabs = [
  {
    id: "results",
    name: "Results",
    roles: ["l4a-trainer", "trainer-organisation", "admin", "courses-admin", "clubs-admin"],
  },
  {
    id: "users",
    name: "Users",
    roles: ["l4a-trainer", "trainer-organisation", "admin", "courses-admin", "clubs-admin"],
  },
];
const selectedTab = route.query.tab ? route.query.tab : ref(tabs[0].id);

const { filters, setFilter, resetFilters, sortBy, getFiltersFromQuery, setFilterNoRefresh } = useFilters(route);

const { countries } = storeToRefs(useGlobalStore());
const locations = countries.value.map(c => c.name);

if (!route.query.page) setFilterNoRefresh("page", "1");

const responses = ref([] as SurveyResponse[]);
const results = ref({} as DetailedResults[]);
const meta = ref({} as PaginationMeta);
const event = ref({} as Event);
const trainers = ref([] as { key: string; value: string }[]);
const eventID = route.params.id;

try {
  getFiltersFromQuery();
  event.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.events.getEvent(String(eventID)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.event;
  try {
    results.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.getSurveyResults(Number(eventID)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.surveyResults;
  } catch (error) {
    results.value = [];
  }
  const usersResponse = (
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.getSurveyUsers(Number(eventID), filters.value))),
  __temp = await __temp,
  __restore(),
  __temp
);
  responses.value = usersResponse.data.users;
  meta.value = usersResponse.meta;
  const trainersResponse = (
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.listSurveysTrainers())),
  __temp = await __temp,
  __restore(),
  __temp
);
  trainers.value = trainersResponse.data.map((t: User) => ({ key: `${t.first_name} ${t.last_name}`, value: `${t.first_name} ${t.last_name}` }));
} catch (error) {
  globalStore.toast("ERROR", "Error loading Survey data");
  window.location.href = "/error";
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TitleHeader, {
        title: event.value?.name
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TabGroup, {
        tabs: tabs,
        selectedTab: _unref(selectedTab),
        onSelect: _cache[0] || (_cache[0] = (tab) => selectedTab.value = tab),
        "has-role-guard": true
      }, null, 8, ["selectedTab"]),
      (_unref(selectedTab) === 'results')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result, index) => {
              return (_openBlock(), _createBlock(ResultsTable, {
                key: result.id,
                index: index,
                result: result,
                response_count: responses.value.length
              }, null, 8, ["index", "result", "response_count"]))
            }), 128)),
            (!results.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No responses to this Survey"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(selectedTab) === 'users')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("users")), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_9, [
                    _createElementVNode("th", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.$t("name")) + " ", 1),
                      _createVNode(SortableTableHeader, {
                        column: "user_last_name",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"])
                    ]),
                    _createElementVNode("th", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createTextVNode(_toDisplayString(_ctx.$t("country")) + " ", 1),
                        (_unref(filters))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(SortableTableHeader, {
                                column: "country",
                                onSort: _unref(sortBy)
                              }, null, 8, ["onSort"]),
                              _createVNode(FilterTableHeader, {
                                label: "country",
                                currentValue: _unref(filters).country,
                                filters: _unref(locations),
                                onChange: _unref(setFilter),
                                onReset: _unref(resetFilters)
                              }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.$t("trainer")) + " ", 1),
                        (_unref(filters))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(SortableTableHeader, {
                                column: "facilitator_last_name",
                                onSort: _unref(sortBy)
                              }, null, 8, ["onSort"]),
                              _createVNode(FilterTableHeader, {
                                label: "trainerId",
                                currentValue: _unref(filters).facilitator_full_name,
                                filters: trainers.value,
                                onChange: _unref(setFilter),
                                onReset: _unref(resetFilters),
                                "is-object-array": true
                              }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", _hoisted_17, [
                      _createTextVNode(_toDisplayString(_ctx.$t("date-completed")) + " ", 1),
                      _createVNode(SortableTableHeader, {
                        column: "responded_at",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"])
                    ]),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("actions")), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responses.value, (response) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "w-full border-b border-gray-400 even:bg-gray-200",
                      key: response.id
                    }, [
                      _createElementVNode("td", _hoisted_19, _toDisplayString(response.user_first_name) + " " + _toDisplayString(response.user_last_name), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(response.country), 1),
                      _createElementVNode("td", _hoisted_21, [
                        (response.facilitator_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(response.facilitator_first_name) + " " + _toDisplayString(response.facilitator_last_name), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23))
                      ]),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(new Date(response.responded_at).toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: `/dashboard/training-feedback/${_unref(eventID)}/reponse/${response.user_id}/`,
                          class: "pr-2 text-blue"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("View")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128)),
                  (!responses.value.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_26, _hoisted_28))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})